import { Spin } from "antd";
import icon from "../../assets/加载.svg";
import "./index.scss";

const SpinIcon = (props) => {
  const { style } = props;
  return (
    <Spin
      style={style}
      indicator={
        <img
          src={icon}
          alt="loading"
          className="afc-svg-spin"
          style={{ width: 14, height: 14 }}
        />
      }
    />
  );
};
export default SpinIcon;
